<template>
  <div class="cardBox" v-for="item in data" :key="item.mobile" @click.stop="clickCard({ ...item })">
    <van-row justify="space-between" class="userRow">
      <van-col span="16">
        <van-row>
          <van-col span="5"
            ><div class="surname themeColor">{{ (item.name && item.name.slice(0, 1)) || '' }}</div></van-col
          >
          <van-col span="18" offset="1">
            <p class="userName ellipsis">{{ item.name }}</p>
            <p class="userPhone">
              <span>{{ item.mobile && item.mobile.slice(0, 3) }}</span>
              <span>{{ item.mobile && item.mobile.slice(3, 7) }}</span>
              <span>{{ item.mobile && item.mobile.slice(7, 11) }}</span>
            </p>
          </van-col>
        </van-row>
      </van-col>
      <van-col v-if="!item.register" span="6">
        <div class="fvlrw handleBox" @click.stop>
          <div class="themeColor" @click.stop="clickBtn({ id: 'update', _data: item })">修改</div>
          <div class="delete" @click.stop="clickBtn({ id: 'delete', _data: item })">删除</div>
        </div>
      </van-col>
      <van-col v-else span="6">
        <div class="fvlrw handleBox" @click.stop>
          注册用户信息
        </div>
      </van-col>
    </van-row>
    <van-row v-if="!item.register" justify="space-between" @click.stop>
      <van-col span="19" class="userName">设为默认</van-col>
      <van-col span="5">
        <van-switch
          v-model="item.defaultStatusFlag"
          size="22px"
          active-color="#3088c5"
          @change="changeSwitch($event, { id: 'switch', _data: item })"
          :active-value="1"
          :inactive-value="0"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue'
// import rowItem from '@/components/oab/row'
// import BottomBtn from '@/components/order/BottomBtn'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    // rowItem,
    // BottomBtn
  },
  emits: ['click', 'clickBtn'],
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value,
      btnData: []
    })
    const clickCard = v => {
      emit('click', v)
    }
    const clickBtn = v => {
      emit('clickBtn', v)
    }
    const changeSwitch = (v, data) => {
      // console.log('changeSwitch', v, data)
      data._data.switch = v
      emit('clickBtn', { ...data })
    }

    let toMyCouponList = ({ path }) => {
      // router.push({ path, query: { event: '我的优惠券列表' } })
    }
    return {
      ...toRefs(state),
      clickCard,
      clickBtn,
      changeSwitch,
      toMyCouponList
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  padding: 12px 20px 15px;
  margin-bottom: 8px;
  background-color: #fff;
  text-align: left;
  font-size: 12px;
  color: #999;
}
.content {
  padding: 12px 0;
  margin: 8px 0 14px;
  border-top: solid 1px #cccccc;
  border-bottom: solid 1px #cccccc;
}

.userRow {
  margin-bottom: 8px;
}
.surname {
  height: 100%;
  background: #e1edf0;
  line-height: 40px;
  vertical-align: middle;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
}
.userName {
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
  font-weight: 700;
}
.userPhone {
  font-size: 14px;
  span {
    margin-right: 4px;
  }
}
.handleBox {
  height: 100%;
}
.delete {
  color: #f55a4f;
}
</style>
